import Vue from 'vue'
import Router from 'vue-router'
import routes from './routers'
Vue.use(Router)
const router = new Router({
    routes,
    mode: 'hash'
})
router.beforeEach((to, from, next) => {
    next()
})
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
    return originalPush.call(this, location).catch(err => err)
}
export default router



// WEBPACK FOOTER //
// ./src/router/index.js